import { GeocodeCoordinates } from './types';

const GEOCODE_BASE_URL = 'https://maps.google.com/maps/api/geocode/json';

export const fetchCoordinatesForAddress = async (
  address: string
): Promise<GeocodeCoordinates | null> => {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  const url = `${GEOCODE_BASE_URL}?key=${apiKey}&address=${encodeURIComponent(address)}`;

  const response = await fetch(url);
  const json = await response.json();

  if (!json.results?.length) {
    return null;
  }

  return json.results[0].geometry.location;
};

export const fetchAddressComponentsAtCoordinates = async (
  coordinates: GeocodeCoordinates
): Promise<any[] | null> => {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  const url = `${GEOCODE_BASE_URL}?key=${apiKey}&latlng=${coordinates.lat},${coordinates.lng}`;

  const response = await fetch(url);
  const json = await response.json();

  if (!json.results?.length) {
    return null;
  }

  return json.results[0].address_components;
};